<template>
  <div>
    <div class="box">
      <!-- 顶部图标 -->
      <div class="space-top">
        <img src="@/assets/whiteback2@2x.png" alt="" @click="comeback()">
        <p>确认订单</p>
      </div>
      <!-- 会员列表 -->
      <ul class="paylist">
        <!-- <li>
          <img src="@/assets/kecheng@2x.png" alt="">
          <p class="payfont">开通VIP会员</p>
          <p class="paymoney">
            <span>198</span>元 / 年
          </p>
        </li> -->
        <li>
          <img src="@/assets/kecheng@2x.png" alt="">
          <p class="payfont">认证E会员</p>
          <p class="paymoney">
            <span>10</span>元 / 年
          </p>
        </li>
        <!-- <li>
          <img src="@/assets/kecheng@2x.png" alt="">
          <p class="payfont">建筑设计训练营训练营训练营训练营训练营训练营</p>
          <p class="paymoney">
            ￥ 1999
          </p>
        </li> -->
      </ul>
      <!-- 手机号 -->
      <!-- <div class="mobile">
        <h2>
          <span></span>
          <p>请输入手机号</p>
        </h2> -->
      <!-- 输入区域 -->
      <!-- <div class="number">
          <div class="num-left">
            +86 <span>∨</span>
          </div>
          <div class="num-right">
            <input v-model="mobile" maxlength="11" type="tel">
          </div>
        </div>
      </div> -->
      <!-- 优惠 -->
      <ul class="youhui">
        <li>
          <img src="@/assets/youhui@2x.png" alt="">
          <p class="first">优惠券</p>
          <p class="second">
            优惠
            <span>30元</span>
          </p>
        </li>
        <!-- <li>
          <img src="@/assets/youhui@2x.png" alt="">
          <p class="first">定金券</p>
          <p class="second">
            抵扣
            <span>30元</span>
          </p>
        </li> -->
      </ul>
      <!-- 支付方式 -->
      <ul class="pay">
        <li>
          <img src="@/assets/wx.png" alt="">
          <p>微信支付<span></span></p>
          <input id="one" v-model="payType" type="radio" name="pay" value="1">
          <label for="one"></label>
        </li>
        <li>
          <img src="@/assets/zfb.png" alt="">
          <p>支付宝支付<span></span></p>
          <input id="tow" v-model="payType" type="radio" name="pay" value="2">
          <label for="tow"></label>
        </li>
        <li>
          <img src="@/assets/jingdong@2x.png" alt="">
          <p>京东支付<span>(可白条分期)</span></p>
          <input id="three" v-model="payType" type="radio" name="pay" value="3">
          <label for="three"></label>
        </li>
      </ul>
      <!-- 价格区域 -->
      <!-- <ul class="moneyinfo">
        <li>
          <p>课程价格</p>
          <p>￥{{ moneyInfo.class }}</p>
        </li>
        <li>
          <p>定金券折扣</p>
          <p>-￥{{ moneyInfo.goldKill }}</p>
        </li>
        <li>
          <p>优惠券折扣</p>
          <p>-￥{{ moneyInfo.huiKill }}</p>
        </li>
        <li>
          <p>VIP购课折扣</p>
          <p>-￥{{ moneyInfo.vipKill }}</p>
        </li>
        <li>
          <p>合计</p>
          <p>￥{{ moneyInfo.all }}</p>
        </li>
      </ul> -->
      <!-- 同意协议 -->
      <div class="xieyi">
        <input id="iptimg" v-model="okInfo" type="checkbox" class="ipt">
        <label for="iptimg"></label>
        <span>同意支付协议</span>
      </div>
      <!-- 底部 -->
      <div class="footer">
        <p>
          应付金额
          <span>￥{{ moneyInfo.all }}</span>
        </p>
        <p @click="pay()">立即支付</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getOption, getMobile } from '@/api/epay'
export default {
  data() {
    return {
      okInfo: true,
      mobile: '',
      reg: new RegExp(/^[1]+[3-9]+\d{9}$/g),
      payType: '',
      moneyInfo: {
        class: 1999,
        goldKill: 200,
        huiKill: 300,
        vipKill: 199,
        all: 1500
      }
    }
  },
  created() {
    this.getFun()
  },
  methods: {
    // 返回上一页
    comeback() {
      this.$router.go(-1)
    },
    getFun() {
      getOption().then(res => {
        if (res.errNo !== 0) {
          console.log(res)
          return
        }
        this.moneyInfo.all = res.result.money
        console.log(res)
      })
    },
    // 支付方式
    // 支付
    pay() {
      const dataInfo = {
        mobile: this.mobile,
        pay_type: this.payType,
        from_sys: 0,
        money_type: 1,
        fromurl: '',
        pcid: '10086'
      }
      getMobile(dataInfo).then(res => {
        // 手机号,同意协议
        if (this.okInfo !== true) {
          console.log('请先同意协议')
          return
        } else if (this.reg.test(this.mobile) !== true) {
          console.log('无效的手机号')
          console.log(this.mobile)
          return
        } else if (this.payType === '') {
          console.log('请选择支付方式')
          return
        } else if (res.errNo !== 0) {
          return
        }
        console.log(res)
        console.log('支付成功')
        // 跳转支付
        window.location = res.result.code_url
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped lang="less">
p{
  margin: 0;
  padding: 0;
  text-align: left;
}
.box{
  width: 750px;
  margin: 0 auto;
  min-height: 100vh;
  overflow: hidden;
  background: #f7f7f7;
}
 // 个人顶部图标
  .space-top {
    background: #000;
    width: 750px;
    padding: 0 28px 0 26px;
    box-sizing: border-box;
    height: 86px;
    line-height: 86px;
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    z-index: 10;
    img {
      width: 45px;
    }
    p{
      font-size: 32px;
      color: #fff;
      margin-left: 238px;
    }
  }
// 会员列表
.paylist{
  margin-top: 86px;
  background: #fff;
  li{
    display: flex;
    align-items: center;
    padding: 50px 28px 52px 26px;
    box-sizing: border-box;
    font-size: 28px;
    position: relative;
    border-bottom: 2px solid #eee;
    .payfont{
      width: 365px;
      white-space: pre-wrap;
      margin-right: 143px;
    }
    .paymoney{
      span{
        color: #f02e2f;
      }
    }
    img{
      position: relative;
      width: 39px;
      height: 42px;
      margin-right: 22px;
    }
  }
}
// 手机号
.mobile{
  width: 100%;
  box-sizing: border-box;
  h2{
    width: 240px;
    margin: 77px auto 28px;
    font-size: 30px;
    font-weight: 600;
    display: flex;
    align-items: center;
    span{
      width: 5px;
      height: 29px;
      background: #ee2d2e;
      display: inline-block;
      margin-right: 15px;
      margin-left: 10px;
    }
  }
  // 输入区域
  .number{
    width: 696px;
    height: 88px;
    margin-left: 28px;
    background: #fff;
    border-radius: 10px;
    border: 2px solid #eee;
    margin-bottom: 34px;
    display: flex;
    align-items: center;
    font-size: 30px;
    .num-left{
      width: 160px;
      text-align: center;
      border-right: 2px solid #eee;
      span{
        display: inline-block;
        font-size: 12px;
        transform: scale(0.8) scaleX(2);
      }
    }
    .num-right{
      width: 100%;
      padding-left: 25px;
      box-sizing: border-box;
    }
  }
}
// 优惠
.youhui{
  width: 100%;
  background: #fff;
  margin-bottom: 22px;
  li{
    font-size: 28px;
    padding: 28px 28px 28px 26px;
    border-bottom: 2px solid #eee;
    display: flex;
    position: relative;
    box-sizing: border-box;
    img{
      position: relative;
      width: 40px;
      top: -2px;
      margin-right: 32px;
    }
    .first{
      width: 499px;
    }
    .second{
      span{
        color:#f02e2f;
      }
    }
  }
}
// 支付方式
.pay{
  width: 100%;
  background: #fff;
  padding: 0 28px 0 26px;
  font-size: 28px;
  margin-bottom: 20px;
  position: relative;
  li{
    border-bottom: 2px solid #eee;
    padding-top:24px;
    padding-bottom: 24px;
    box-sizing: border-box;
    display: flex;
    img{
      width: 43px;
      margin-right: 30px;
    }
    p{
      width: 573px;
      span{
        color: #ee2d2e;
      }
    }
    #one,#tow,#three{
      width: 45px;
      height: 45px;
      margin-top: -4px;
    }
    #one + label,#tow + label,#three + label{
      display: block;
      cursor: pointer;
      position: absolute;
      right: 32px;
      margin-top: -5px;
    }
    #one:checked + label::before,
    #tow:checked + label::before,
    #three:checked + label::before{
      display: block;
      content: '\2714';
      text-align: center;
      width: 47px;
      height: 47px;
      font-size: 28px;
      line-height: 47px;
      border-radius: 100%;
      color: white;
      background: rgba(240, 84, 77, 1);
    }
  }
}
// 价格明细
.moneyinfo{
  width: 100%;
  padding: 0 28px 0 26px;
  background: #fff;
  padding-top: 43px;
  padding-bottom: 2px;
  box-sizing: border-box;
  li{
    color: #999;
    font-size: 28px;
    display: flex;
    justify-content: space-between;
    margin-bottom:25px;
  }
  li:last-child{
    margin-top: 19px;
    p:last-child{
      font-size: 30px;
      color: #ee2d2e;
    }
  }
}
//协议
.xieyi{
  width: 100%;
  display: flex;
  justify-content: start;
  margin-top: 24px;
  margin-bottom: 137px;
  padding: 0 28px 0 26px;
  box-sizing: border-box;
  position: relative;
  .ipt{
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }
  span{
    color: #dab38c;
    font-size: 22px;
    display: inline-block;
    margin-left: 9px;
    vertical-align: middle;
  }
  .ipt + label {
  display: block;
  cursor: pointer;
  position: absolute;
  top: -2px;
  left: 24px;
}
.ipt:checked + label::before {
  display: block;
  content: '\2714';
  text-align: center;
  width: 36px;
  height: 36px;
  font-size: 24px;
  border-radius: 8px;
  color: white;
  background: rgba(240, 84, 77, 1);
}
}
// 底部
.footer{
  width: 750px;
  height: 100px;
  background: #fff;
  padding:0 28px 0 28px ;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  p:first-child{
    color: #999;
    font-size: 23px;
    span{
      color: #ee2d2e;
      font-size: 38px;
    }
  }
  p:last-child{
    position: relative;
    right: -28px;
    height: 99px;
    width: 260px;
    background: #ee2e2e;
    // background: #ee2e2e;
    color: #fff;
    text-align: center;
    line-height: 100px;
    font-size: 28px;
  }
}
</style>
